import { setAlert } from '../alert';
import {
    API_POST_TIGERCAT_BURNS_CREATE_CAR_RPPB,
    API_GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS,
    API_POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT,
    API_GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS,
    API_GET_TIGERCAT_BURNS_GET_USERS,
    API_POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS,
    API_GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS,
    API_POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT,
    API_GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT,
    API_GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER,
    API_PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT,
    API_GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS,
    API_PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT,
    API_GET_TABLE_TOTAL_RECORD_COUNT,
    API_PROJECT_DESCRIPTION,
    API_ROLES_AND_RESPONSIBILITIES,
    API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE,
    API_TIGERCAT_BURNS_DOCUMENT_UPLOADS
} from './constants/tigercat-base-constants';

import {
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_FAIL,
    GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_FAIL,
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_FAIL,
    GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_FAIL,
    GET_TIGERCAT_BURNS_GET_USERS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_USERS_FAIL,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_FAIL,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_FAIL,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_SUCCESS,
    POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_FAIL,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_SUCCESS,
    GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_FAIL,
    GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_SUCCESS,
    GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_FAIL,
    PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_SUCCESS,
    PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_FAIL,
    GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_FAIL,
    PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_SUCCESS,
    PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_FAIL,
    API_GET_TABLE_TOTAL_RECORD_COUNT_SUCCESS,
    API_GET_TABLE_TOTAL_RECORD_COUNT_FAIL,
    API_PROJECT_DESCRIPTION_SUCCESS,
    API_PROJECT_DESCRIPTION_FAIL,
    API_ROLES_AND_RESPONSIBILITIES_SUCCESS,
    API_ROLES_AND_RESPONSIBILITIES_FAIL,
    API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_SUCCESS,
    API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_FAIL,
    API_GET_UPLOADED_DOCUMENTS_SUCCESS,
    API_GET_UPLOADED_DOCUMENTS_FAIL,
    API_POST_UPLOADED_DOCUMENTS_SUCCESS,
    API_POST_UPLOADED_DOCUMENTS_FAIL
} from './types/tigercat-base-types';

import api from '../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json',
    },
};

const formDataConfig = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
}

export const getTigercatUsers = () => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_USERS,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_USERS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_USERS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const createCompanyCarRppb = (data, companyId) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_CREATE_CAR_RPPB + `/${companyId}`,
            data,
            config
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getCompanyUserCarRppbs = (companyId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS + `/${companyId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_COMPANY_USER_CAR_RPPBS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const createUserCarRppbProject = (carRppbId, data) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT + `/${carRppbId}`,
            data,
            config
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_CAR_RPPB_PROJECT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getCarRppbProjects = (carRppbId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS + `/${carRppbId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_CAR_RPPB_PROJECTS_FAIL,
            payload: err.response.data.detail,
        });
    }
};


// Action to create biochar bins
export const createBiocharBins = (binData, companyId) => async (dispatch) => {
    try {
        const response = await api().post(process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS + `/${companyId}`, binData, config);
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_BIOCHAR_BINS_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

// Action to get user biochar bins
export const getCompanyBiocharBins = (companyId) => async (dispatch) => {
    try {
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS + `/${companyId}`, config);
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_BINS_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

// Action to create biochar equipment
export const createBiocharEquipment = (equipmentData, companyId) => async (dispatch) => {
    try {
        const response = await api().post(process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT + `/${companyId}`, equipmentData, config);
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: POST_TIGERCAT_BURNS_CREATE_BIOCHAR_EQUIPMENT_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

// Action to get user biochar equipment
export const getCompanyBiocharEquipment = (companyId) => async (dispatch) => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT + `/${companyId}`, config);
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_USER_BIOCHAR_EQUIPMENT_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

// Action to get projects for company
export const getProjectsForCompany = (companyId) => async (dispatch) => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER + `/${companyId}`, config);
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_SUCCESS,
            payload: response
        });
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_PROJECTS_FOR_USER_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

// Action assign assets to project
export const assignAssetToProject = (projectId, assetType, assetId) => async (dispatch) => {
    try {
        const response = await api().patch(process.env.REACT_APP_API_URL + API_PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT + `/${projectId}/${assetType}/${assetId}`, {}, config);
        dispatch({
            type: PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_SUCCESS,
            payload: response
        });
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: PATCH_TIGERCAT_BURNS_ASSIGN_ASSET_TO_PROJECT_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

export const UnassignAssetFromProject = (projectId, assetType, assetId) => async (dispatch) => {
    try {
        const response = await api().patch(process.env.REACT_APP_API_URL + API_PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT + `/${projectId}/${assetType}/${assetId}`, {}, config);
        dispatch({
            type: PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_SUCCESS,
            payload: response
        });
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: PATCH_TIGERCAT_BURNS_UNASSIGN_ASSET_FROM_PROJECT_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

export const getAllProjectsWithAssignedAssets = (companyId, assetTyoe) => async (dispatch) => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS + `/${companyId}/${assetTyoe}`, config);
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_ALL_PROJECTS_WITH_ASSIGNED_ASSETS_FAIL,
            payload: error.response ? error.response.data : error.message
        });
    }
};

export const getTableTotalRecordCount = (carRppbProjectId, tableName) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_GET_TABLE_TOTAL_RECORD_COUNT}/${carRppbProjectId}/${tableName}`,
            config
        );
        dispatch({
            type: API_GET_TABLE_TOTAL_RECORD_COUNT_SUCCESS,
            payload: data,
        });
        // dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_GET_TABLE_TOTAL_RECORD_COUNT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getProjectDescription = (carRppbProjectId, type) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_PROJECT_DESCRIPTION}/${carRppbProjectId}/${type}`,
            config
        );
        dispatch({
            type: API_PROJECT_DESCRIPTION_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_PROJECT_DESCRIPTION_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postProjectDescription = (carRppbProjectId, type, descriptionData) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_PROJECT_DESCRIPTION}/${carRppbProjectId}/${type}`,
            descriptionData,
            config
        );
        dispatch({
            type: API_PROJECT_DESCRIPTION_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_PROJECT_DESCRIPTION_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRolesAndResponsibilities = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_ROLES_AND_RESPONSIBILITIES}/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: API_ROLES_AND_RESPONSIBILITIES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_ROLES_AND_RESPONSIBILITIES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postRolesAndResponsibilities = (carRppbProjectId, rolesData) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_ROLES_AND_RESPONSIBILITIES}/${carRppbProjectId}`,
            rolesData,
            config
        );
        dispatch({
            type: API_ROLES_AND_RESPONSIBILITIES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_ROLES_AND_RESPONSIBILITIES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getEquipmentMaintenance = (companyId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE}/${companyId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postEquipmentMaintenance = (companyId, rowsPerPage, currentPage, maintenanceData) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE}/${companyId}/${rowsPerPage}/${currentPage}`,
            maintenanceData,
            formDataConfig
        );
        dispatch({
            type: API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_TIGERCAT_BURNS_EQUIPMENT_MAINTENANCE_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getUploadedDocuments = (rowsPerPage, currentPage, documentType) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_TIGERCAT_BURNS_DOCUMENT_UPLOADS}/${rowsPerPage}/${currentPage}/${documentType}`,
            config
        )
        dispatch({
            type: API_GET_UPLOADED_DOCUMENTS_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: API_GET_UPLOADED_DOCUMENTS_FAIL,
            payload: error.response.data.detail,
        });
    }
}

export const postUploadedDocuments = (formData, rowsPerPage, currentPage, documentType) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_TIGERCAT_BURNS_DOCUMENT_UPLOADS}/${rowsPerPage}/${currentPage}/${documentType}`,
            formData,
            formDataConfig
        )
        dispatch({
            type: API_POST_UPLOADED_DOCUMENTS_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: API_POST_UPLOADED_DOCUMENTS_FAIL,
            payload: error.response.data.detail,
        });
    }
}